export const ssjzRoute = [
  {
    path: '/ssjz/list',
    component: () => import('./views/list')
  },
  {
    path: '/ssjz/detail',
    component: () => import('./views/detail')
  }
]



// WEBPACK FOOTER //
// ./src/page/ssjz/ssjzRoute.js